<template>
    <div class="kgr-row">
        <div>
            <div class="kgr-postfix kgr-postfix--gutters kgr-postfix--top kgr-row">
                <div class="kgr-postfix__fluid">
                    <kgr-view-picker
                        :value="view"
                        @post-input="updateView"
                    />
                </div>
                <div
                    v-if="canCreateNew"
                    class="kgr-postfix__fixed"
                >
                    <a
                        class="kgr-button kgr-button--accent"
                        :href="createUrl"
                    >
                        <kgr-icon
                            icon-class="add"
                            small
                            circle
                            highlight
                            class="kgr-button__icon kgr-button__icon--left"
                        />
                        <span v-t="'Neue Abteilung hinzufügen'"></span>
                    </a>
                </div>
                <div class="kgr-postfix__fixed">
                    <kgr-print-button />
                </div>
            </div>

            <div class="kgr grid kgr-grid--inline kgr-grid--gutters kgr-row">
                <div class="kgr-grid__cell">
                    <label class="kgr-inputGroup">
                        <div
                            v-t="'search'"
                            class="kgr-inputGroup__label"
                        ></div>
                        <input
                            v-model="filter"
                            type="text"
                            class="kgr-input"
                        />
                    </label>
                </div>

                <div
                    v-if="view === 'grid'"
                    class="kgr-grid__cell animated fadeIn"
                >
                    <label class="kgr-inputGroup">
                        <div
                            v-t="'Unter-Abteilungen anzeigen'"
                            class="kgr-inputGroup__label"
                        ></div>
                        <kgr-checkbox
                            :checked="includeChildren"
                            @change="updateIncludeChildren"
                        />
                    </label>
                </div>
            </div>
        </div>

        <kgr-departments-data-provider
            v-slot="departmentsScope"
            :club-id="clubId"
        >
            <div>
                <kgr-empty-data
                    v-if="departmentsScope.data.length === 0"
                    :value="$t('Es wurden noch keine Abteilungen angelegt.')"
                />

                <kgr-departments-list
                    v-else
                    :departments="departmentsScope.data"
                    :filter="filter"
                    :view="view"
                    :include-children="includeChildren"
                />
            </div>
        </kgr-departments-data-provider>
    </div>
</template>

<script>
import Checkbox from '../../components/common/form/checkbox/Checkbox';
import DepartmentsDataProvider from '../../components/data-provider/DepartmentsDataProvider';
import EmptyData from '../../components/common/EmptyData';
import Icon from '../../components/common/icon/Icon';
import KgrDepartmentsList from '../../components/departments/DepartmentsList';
import PrintButton from '../../components/common/form/button/PrintButton';
import ViewPicker from '../../components/common/form/picker/ViewPicker';

const DEPARTMENTS_OVERVIEW_VIEW = 'kgr:departments:overview:view';
const DEPARTMENTS_OVERVIEW_INCLUDE_CHILDREN = 'kgr:departments:overview:include-children';

export default {
    components: {
        'kgr-checkbox': Checkbox,
        KgrDepartmentsList,
        'kgr-departments-data-provider': DepartmentsDataProvider,
        'kgr-empty-data': EmptyData,
        'kgr-print-button': PrintButton,
        'kgr-view-picker': ViewPicker,
        'kgr-icon': Icon,
    },
    props: {
        clubId: {
            type: Number,
            required: true,
        },
        createUrl: {
            type: String,
            required: true,
        },
        canCreateNew: {
            type: Boolean,
            required: true,
        },
    },
    data() {
        return {
            filter: null,
            includeChildren: true,
            view: 'grid',
        };
    },
    created() {
        const view = localStorage.getItem(DEPARTMENTS_OVERVIEW_VIEW);
        if (view !== null && view !== '') {
            this.view = view;
        }

        const includeChildren = localStorage.getItem(DEPARTMENTS_OVERVIEW_INCLUDE_CHILDREN);
        if (view !== null) {
            this.incl = includeChildren;
        }
    },
    methods: {
        updateView(view) {
            this.view = view;

            if (view !== null) {
                localStorage.setItem(DEPARTMENTS_OVERVIEW_VIEW, view);
            } else {
                localStorage.removeItem(DEPARTMENTS_OVERVIEW_VIEW);
            }
        },
        updateIncludeChildren(includeChildren) {
            this.includeChildren = includeChildren;

            if (includeChildren !== null) {
                localStorage.setItem(DEPARTMENTS_OVERVIEW_INCLUDE_CHILDREN, includeChildren);
            } else {
                localStorage.removeItem(DEPARTMENTS_OVERVIEW_INCLUDE_CHILDREN);
            }
        },
    },
};
</script>

<style scoped lang="scss" rel="stylesheet/scss">
</style>
